import { TextField, FormControl } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginTop: '12px',
  width: '100%',

  '& .MuiInputLabel-root': {
    backgroundColor: 'transparent',
    color: `${theme.palette.primary.main} !important`,
    fontWeight: 'bold',
    '&.MuiInputLabel-shrink': {
      backgroundColor: theme.palette.background.paper || 'white',
      padding: '0 4px',
      transform: 'translate(14px, -9px) scale(0.75)',
      color: `${theme.palette.primary.main} !important`,
    },
    '&.Mui-focused': {
      color: `${theme.palette.primary.main} !important`,
    },
    '&.MuiFormLabel-filled': {
      color: `${theme.palette.primary.main} !important`,
    },
  },

  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
      opacity: 0.8,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 3,
      opacity: 0.6,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 3,
    },
  },

  '@media (max-width: 600px)': {
    marginTop: '8px',
    '& .MuiInputLabel-root': {
      fontSize: '14px',
    },
  },
}));

const CustomTextArea = ({
  label,
  id,
  name,
  value,
  onChange,
  sx = {},
  size = 'medium',
  variant = 'outlined',
  shrinkLabel = true,
  minRows = 3,
  maxRows = 20,
  ...props
}) => {
  const SIZES = {
    small: { minHeight: '40px', fontSize: '14px', labelSize: '12px' },
    medium: { minHeight: '56px', fontSize: '18px', labelSize: '18px' },
    large: { minHeight: '64px', fontSize: '18px', labelSize: '16px' },
    xlarge: { minHeight: '72px', fontSize: '20px', labelSize: '18px' },
  };

  const sizeConfig = SIZES[size] || SIZES.medium;

  const baseStyles = {
    '& .MuiOutlinedInput-root': {
      minHeight: sizeConfig.minHeight,
      fontSize: sizeConfig.fontSize,
      alignItems: 'flex-start',
      paddingTop: '14px',
      paddingBottom: '14px',
    },
    '& .MuiInputBase-input': {
      fontSize: sizeConfig.fontSize,
      padding: '0 14px',
      lineHeight: 1.5,
    },
    '& .MuiInputLabel-root': {
      fontSize: sizeConfig.labelSize,
      color: `${(theme) => theme.palette.primary.main} !important`,
      fontWeight: 'bold',
      '&.MuiInputLabel-shrink': {
        fontSize: sizeConfig.labelSize,
        transform: 'translate(14px, -9px) scale(0.75)',
        backgroundColor: 'white',
        padding: '0 4px',
        color: `${(theme) => theme.palette.primary.main} !important`,
      },
      '&.Mui-focused': {
        color: `${(theme) => theme.palette.primary.main} !important`,
      },
      '&.MuiFormLabel-filled': {
        color: `${(theme) => theme.palette.primary.main} !important`,
      },
    },
    ...sx,
  };

  return (
    <StyledFormControl sx={baseStyles}>
      <TextField
        label={label}
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        variant={variant}
        multiline
        minRows={minRows}
        maxRows={maxRows}
        InputLabelProps={{
          shrink: shrinkLabel,
        }}
        {...props}
      />
    </StyledFormControl>
  );
};

export default CustomTextArea;
